import React, { useEffect, useState } from 'react'
import form1 from '../../constants/form1';
import MasterInput from '../MasterInput';
import { FormService, showErrorAlert } from '../services/Form2.service';
import { showSuccessAlert } from '../services/Form1.service';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

function AdmissionForm({course,part}) {

  const { isLoggedIn, userData, loginModale } = useSelector((state) => state.auth)
  const [searchParams,setSearchParams]=useSearchParams();
  const [step,setStep]=useState(Object.keys(form1)[0]);
  const [isLoading,setIsLoading]=useState(false);
  const [validationError,setValidationError]=useState({});
  const [formData,setFormData]=useState(JSON.parse(localStorage.getItem("courseFormV")||'{}'));

  const addQueryParam = (val) => { setSearchParams({ ...Object.fromEntries(searchParams), "subject_group": val })};


  useEffect(() => {

    const { first_major_subject:s1, second_major_subject:s2, minor_subject:s3 } = formData;

    if(window.location.toString().split("/")[4]==="bsc"){
      if(["Zoology","Botany","Chemistry"].includes(s1)) addQueryParam("ZBC") 
      else addQueryParam("PCM");
    }

    if (
        (s1 === s2 && !(s2 === undefined || s2 === '')) ||
        (s1 === s3 && !(s1 === undefined || s1 === '')) ||
        (s2 === s3 && !(s2 === undefined || s2 === ''))) 
     {
    
        Swal.fire({
          icon: 'error',
          title: 'Subject Conflict',
          text: 'Please select different subjects.',
          confirmButtonText: 'OK',
        }).then((result) => {
          if (result.isConfirmed) {
          
            setFormData((prev) => ({
              ...prev,
              second_major_subject: '', 
              minor_subject:'' 
            }));

            const courseName = localStorage.getItem("courseFormV") || "{}";
            const courseData = JSON.parse(courseName);
            courseData["second_major_subject"]="";
            courseData["minor_subject"]="";
            localStorage.setItem("courseFormV",JSON.stringify(courseData))

          }
        })
      }
  },
  [  
    formData.first_major_subject,
    formData.second_major_subject,
    formData.minor_subject
  ])


  const email = (() => {
  const e1 = userData?.email;
  const e2 = userData?.admissions?.[0]?.applicant_email;
  const isValid = (e) => e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  return isValid(e1) ? e1 : isValid(e2) ? e2 : "";
})();

  useEffect(()=>{

    setFormData({
      ...formData,




      urn:userData?.admissions[0]?.urn || "",
      aadhar_no:userData?.userid ||  userData?.admissions[0]?.aadhar || "",

      applicant_name:userData?.name || userData?.admissions[0]?.applicant_name ||  "",

      email:email || " ",


   applicant_mobile: userData?.admissions[0]?.applicant_mobile || userData.phone_number || "",

      mother_name:userData?.admissions[0]?.mother_name || "",
      father_name:userData?.admissions[0]?.father_name || "",
      dob:userData?.admissions[0]?.dob || "",
      gender:userData?.admissions[0]?.gender === "1" ? "male" : (userData?.admissions[0]?.gender === "2" ? "female" : "other") || "",
      category:userData?.admissions[0]?.category || "",
      sub_category:userData?.admissions[0]?.sub_category || "",
      religion:userData?.admissions[0]?.religion || "",
    
      whatsapp_number:userData?.admissions[0]?.whatsapp_number || "",
     
      c_address:userData?.admissions[0]?.c_address || "",
      p_address:userData?.admissions[0]?.p_address || "",
      same_as_correspondence:userData?.admissions[0]?.same_as_correspondence || "",
      local_guardian_name:userData?.admissions[0]?.local_guardian || "",
      local_guardian_contact:userData?.admissions[0]?.local_guardian_contact || "",
      local_guardian_address:userData?.admissions[0]?.local_guardian_address || "",
      horizontal_reservation:userData?.admissions[0]?.horizontal_reservation || "",
      weightage:userData?.admissions[0]?.weightage || "",
      nationality:userData?.admissions[0]?.nationality || "",
      is_minority:userData?.admissions[0]?.is_minority === 1 ? "yes" :"no" || "",
      is_otherenrollment:userData?.admissions[0]?.is_otherenrollment || "",
      is_upresidence:userData?.admissions[0]?.is_upresidence  === 1 ? "yes" :"no" || "",
      annual_income:userData?.admissions[0]?.annual_income || "",
      income_certificate_no:userData?.admissions[0]?.income_certificate || "",
      bank_name:userData?.admissions[0]?.bank_name || "",
      bank_branch:userData?.admissions[0]?.bank_branch || "",
      bank_account:userData?.admissions[0]?.bank_account || "",
      bank_isfsc:userData?.admissions[0]?.bank_isfsc || "",
      high_school_year:userData?.admissions[0]?.highschool_year || "",
      high_school_board:userData?.admissions[0]?.highschool_board || "",
      high_school_name:userData?.admissions[0]?.highschool_name || "",
      high_school_roll:userData?.admissions[0]?.highschool_roll || "",
      high_school_maxmarks:userData?.admissions[0]?.highschool_maxmarks || "",
      high_school_obtmarks:userData?.admissions[0]?.highschool_obtmarks || "",
      high_school_percentage:userData?.admissions[0]?.highschool_percentage || "",
      high_school_subject:userData?.admissions[0]?.highschool_subject || "",
      intermediate_year:userData?.admissions[0]?.i_year || "",
      intermediate_board:userData?.admissions[0]?.i_board || "",
      intermediate_name:userData?.admissions[0]?.i_name || "",
      intermediate_roll:userData?.admissions[0]?.i_roll || "",
      intermediate_maxmarks:userData?.admissions[0]?.i_maxmarks || "",
      intermediate_obtmarks:userData?.admissions[0]?.i_obtmarks || "",
      intermediate_percentage:userData?.admissions[0]?.i_percentage || "",
      intermediate_subject:userData?.admissions[0]?.i_subject || "",
      first_major_subject:userData?.admissions[0]?.compulsory_subjects.split(",")[0] || "",
      second_major_subject:userData?.admissions[0]?.compulsory_subjects.split(",")[1] || "",
      minor_subject:userData?.admissions[0]?.compulsory_subjects.split(",")[2] || "",
      signature:userData?.admissions[0]?.signature_file || "",
      image:userData?.admissions[0]?.image_file || "",
      is_otherenrollment:userData?.admissions[0]?.is_otherenrollment || "",
      has_scholarship:userData?.admissions[0]?.has_scholarship === 0 ? "yes" : "no" || "",
      is_casefiled:userData?.admissions[0]?.is_casefiled || "",
      is_rustigated:userData?.admissions[0]?.is_rustigated || "",
      is_civilservant:userData?.admissions[0]?.is_civilservant || "",
      is_ufmeans:userData?.admissions[0]?.is_ufmeans || "",
      part:part === "Part-2" ? 2 : part === "Part-1" && 1,
            
    })



  },[])

  useEffect(()=>{
    if(formData.same_as_correspondence==="yes"){
      setFormData((prev)=>({
      ...prev,
      p_address:formData.c_address
      }))
    }else{

    } 
  },[formData.same_as_correspondence,formData.c_address])

  useEffect(() => {
    const max1 = parseFloat(formData.intermediate_maxmarks);
    const obt1 = parseFloat(formData.intermediate_obtmarks);

    if (!isNaN(max1) && !isNaN(obt1) && max1 > 0) {
      const percentage = ((obt1 / max1) * 100).toFixed(2);
      setFormData(prev => ({
        ...prev,
        intermediate_percentage: percentage
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        intermediate_percentage: ''
      }));
    }
  }, [formData.intermediate_maxmarks, formData.intermediate_obtmarks])

  useEffect(() => {
    const max = parseFloat(formData.high_school_maxmarks);
    const obt = parseFloat(formData.high_school_obtmarks);

    if (!isNaN(max) && !isNaN(obt) && max > 0) {
      const percentage = ((obt / max) * 100).toFixed(2);
      setFormData(prev => ({
        ...prev,
        high_school_percentage: percentage
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        high_school_percentage: ''
      }));
    }
  }, [formData.high_school_maxmarks, formData.high_school_obtmarks])



    useEffect(() => {
    const max = parseFloat(formData.ug_1styear_maxmarks);
    const obt = parseFloat(formData.ug_1styear_obtmarks);

    if (!isNaN(max) && !isNaN(obt) && max > 0) {
      const percentage = ((obt / max) * 100).toFixed(2);
      setFormData(prev => ({
        ...prev,
        ug_1styear_percentage: percentage
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        ug_1styear_percentage: ''
      }));
    }
  }, [formData.ug_1styear_maxmarks, formData.ug_1styear_obtmarks])


  const handleSubmit = async()=>{
    setIsLoading(true);
      const response = await FormService.submitForm(formData,course);
      setIsLoading(false);
      if(response.response===false){
          
          setValidationError(response.errors)
          showErrorAlert(response.message)
      }else{
        showSuccessAlert(response.message)
        localStorage.setItem("admission_code",response.admission_code);
        localStorage.removeItem("courseFormV")
        window.location.href="/admission-form/print/"+response.admission_code;
      }
      
  }

  function countSubsetMatches(subset, superset) {
    return subset.filter(val => superset.includes(val)).length;
  }

  const handleChange = (e) => {
    const courseName = localStorage.getItem("courseFormV") || "{}";
    const courseData = JSON.parse(courseName);

    const { name, value, files,type } = e.target;
  
    if (name === "image" || name === "signature") {
      // store file in state but only reference filename in localStorage
      courseData[name] = files[0]?.name || "";
      setFormData((prev) => ({ ...prev, [name]: files[0] })); 
      
    } else {
      const baseName = name.replace("[]", "");

    if (type === "checkbox") {
      const existing = formData[baseName] || [];
      const updated = "checked"
        ? [...existing, value]
        : existing.filter(v => v !== value);
      
      setFormData(prev => ({ ...prev, [baseName]: updated }));
    }
      else{
      courseData[name] = value;
      setFormData((prev) => ({ ...prev, [name]: value }));
      }
    
      
    }

    localStorage.setItem("courseFormV", JSON.stringify(courseData));
  };

  const handleNext = ()=>{
      const keys = Object.keys(form1);
      for(let i=0;i<keys.length; i++){
        if(keys[i]===step){
          setStep(keys[i+1])
        }
      }
  }

  const handlePrev = ()=>{
      const keys = Object.keys(form1);
      const stepsLength = keys.length;
      for(let i=0;i<keys.length; i++){
        if(keys[i]===step){
          setStep(keys[i-1])
        }
      }
  } 

  const isSubmitted=false;


  return (
    <div className="multi-step-form-container">
     <div className="progress-bar">
              {Object.keys(form1).map((section,index) => (
              <div key={index}>
                  <div
                  className={`progress-step ${
                      step === section ? "active" : ""
                  } ${
                      isSubmitted ? "disabled" : ""
                  } ${countSubsetMatches(Object.keys(validationError),form1[section].map((m)=> (m.name||"").replace("[]","")))>0?"has-error":""}`}
                  onClick={() => { 
                      setStep(section)
                  }}
                  >
                  <div  className="step-number" style={{textTransform:'capitalize'}}>{section.split("_")[0]}
                      {countSubsetMatches(Object.keys(validationError),form1[section].map((m)=> (m.name||"").replace("[]","")))>0?
                      <span className='rounded'> {countSubsetMatches(Object.keys(validationError),form1[section].map((m)=> (m.name||"").replace("[]","")))} </span>:""}

                  </div>
                  </div>
              </div>
              ))}
      </div> 
      <p  onClick={()=>console.log(formData)}>Validation Errors {Object.keys(validationError).length}</p>
      <div className="main-form">
        <div className="form-section">
        <h2>Part {Object.keys(form1).findIndex((k) => k === step)+1}: <span style={{textTransform:'capitalize'}}>{step.replace("_"," ")}</span> </h2>
      </div>
        
      <form onSubmit={()=>{}} className="form">

            {form1[step].map(((i)=> <MasterInput
              field={i}
              part={part}
              formData={formData}
              handleChange={handleChange}
              validationError={validationError}
            />
            ))}

      </form>

      <div className="buttons-box">
        <div className="section-count" style={{fontWeight:'normal'}}>Step {Object.keys(form1).findIndex((k) => k === step)+1} of 6
        </div>
        <div>
          {(step!==Object.keys(form1)[Object.keys(form1).length-1] && step!==Object.keys(form1)[0]) && (
                  <button
                    type="button"
                    className="btn btn-previous"
                    onClick={()=>{handlePrev()}}
                    disabled={isLoading}
                  >
                    Previous
                  </button>
          )}

          {step < 6 ? (
                    <button
                      type="button"
                      className="btn btn-next"
                      onClick={handleNext}
                      disabled={isLoading}
                    >
                      {isLoading ? "Loading..." : "Next"}
                    </button>
          ) :Object.keys(form1)[Object.keys(form1).length-1]===step? (
          <>
                      <button
                        type="button"
                        className="btn btn-previous"
                        onClick={()=>{handlePrev()}}
                        disabled={isLoading}
                      >
                        Previous
                      </button>
                      <button
                      onClick={()=>handleSubmit()}
                        type="submit"
                        className="btn btn-submit"
                        disabled={!formData.agreed_to_declaration || isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
          </>
          ):(
          <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-submit"
                        disabled={isLoading}
                      >
                        {isLoading ? "Saving." : "Next"}
          </button>
          )
          }
        </div>
      </div>
    </div>
    </div>
    )
  }

export default AdmissionForm